import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "../styles/MyRaces.css";
import cible from "../../medias/png/icons/cible.png";

const dateOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

const formatDateFR = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const normalizeCountryToFlagName = (country) =>
  String(country || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ /g, "_")
    .toLowerCase();

const MyRaces = ({ races, today }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const filteredRaces = useMemo(() => {
    const racesSafe = races || [];
    const baseToday = today instanceof Date ? today : new Date();
    const todayOnly = dateOnly(baseToday);

    return racesSafe.filter((race) => {
      const d = new Date(race?.date_start);
      if (Number.isNaN(d.getTime())) return false;
      return dateOnly(d) >= todayOnly;
    });
  }, [races, today]);

  const handleRowClick = (raceId) => {
    navigate(`/show-race-detail/${raceId}`);
  };

  return (
    <section className="my-races">
      <h2>{t("myRaces.title")}</h2>

      <div className="my-races-table">
        <div className="my-races-table-container">
          <table>
            <thead>
              <tr>
                <th>{t("myRaces.table.race")}</th>
                <th>{t("myRaces.table.date")}</th>
                <th>{t("myRaces.table.category")}</th>
                <th>{t("myRaces.table.division")}</th>
                <th>{t("myRaces.table.courseType")}</th>
                <th>{t("myRaces.table.profile")}</th>
                <th>{t("myRaces.table.steps")}</th>
              </tr>
            </thead>

            <tbody>
              {filteredRaces.length > 0 ? (
                filteredRaces.map((race) => (
                  <tr
                    key={race.raceId}
                    onClick={() => handleRowClick(race.raceId)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>
                      <div className="my-races-name-container">
                        {race.isBonus === 1 && (
                          <img
                            src={cible}
                            alt={t("myRaces.bonusAlt")}
                            className="my-races-name-container-image"
                          />
                        )}

                        <img
                          className="select-races-table-flag-icon"
                          src={`${process.env.PUBLIC_URL}/flags/${normalizeCountryToFlagName(
                            race.country
                          )}.png`}
                          alt={t("myRaces.flagAlt", { country: race.country })}
                          width="20"
                          height="20"
                        />

                        <span>{race.name}</span>
                      </div>
                    </td>

                    <td>{formatDateFR(race.date_start)}</td>
                    <td>{race.category}</td>
                    <td>{race.division}</td>
                    <td>{race.courseType}</td>
                    <td>{race.profil ?? "-"}</td>
                    <td>{race.step}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    {t("myRaces.empty")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default MyRaces;
